"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _autobahnUtilities = require("@gcc/autobahn-utilities");

var _nanoid = require("nanoid");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _server = require("react-dom/server");

var _reactMarkdown = _interopRequireDefault(require("react-markdown"));

var _DictionaryTerms = _interopRequireDefault(require("./DictionaryTerms.context"));

var _DictionaryTerms2 = _interopRequireDefault(require("./DictionaryTerms.index"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var doesIndexOverlapHtmlTags = function doesIndexOverlapHtmlTags(indexToCheck, indicesTakenByHtmlTags) {
  return !!indicesTakenByHtmlTags.find(function (_ref) {
    var startIndex = _ref.startIndex,
        endIndex = _ref.endIndex;
    return startIndex < indexToCheck && indexToCheck < endIndex;
  });
};

var getIndicesTakenByHtmlTags = function getIndicesTakenByHtmlTags(stringToCheck) {
  var indicesTakenByHtmlTags = [];
  var lastOpenBracketIndex = 0;
  stringToCheck.split('').forEach(function (symbol, index) {
    if (symbol === '<') {
      lastOpenBracketIndex = index;
    } else if (symbol === '>') {
      indicesTakenByHtmlTags.push({
        startIndex: lastOpenBracketIndex,
        endIndex: index
      });
    }
  });
  return indicesTakenByHtmlTags;
};

var parseDictionaryTerms = function parseDictionaryTerms(_ref2) {
  var dictionaryTerms = _ref2.dictionaryTerms,
      text = _ref2.text;
  var productDescriptionWithDictionaryTerms = "".concat(text).replace(/(\r\n|\n|\r)/gm, ' ');
  dictionaryTerms.forEach(function (_ref3) {
    var term = _ref3.Term,
        isCaseSensitive = _ref3.IsCaseSensitive,
        liveClickerVideoTag = _ref3.LiveClickerVideoTag;

    if ((0, _autobahnUtilities.isEmptyOrSpaces)(term)) {
      return;
    }

    var regexFlags = isCaseSensitive ? 'g' : 'gi';
    var termToMatch = new RegExp("(\\b".concat(term, "\\b)(?!(.(?!<a))*</a>)"), regexFlags);
    var indicesTakenByHtmlTags = getIndicesTakenByHtmlTags(productDescriptionWithDictionaryTerms);
    productDescriptionWithDictionaryTerms = productDescriptionWithDictionaryTerms.replace(termToMatch, function (match, matchIndex) {
      if (doesIndexOverlapHtmlTags(matchIndex, indicesTakenByHtmlTags)) return match;
      return (0, _server.renderToString)( /*#__PURE__*/_react["default"].createElement(_DictionaryTerms2["default"], {
        term: match,
        liveClickerVideoTag: liveClickerVideoTag
      }));
    });
  });
  return productDescriptionWithDictionaryTerms;
};

var DictionaryTermsWrapper = function DictionaryTermsWrapper(_ref4) {
  var children = _ref4.children,
      _ref4$markdown = _ref4.markdown,
      markdown = _ref4$markdown === void 0 ? false : _ref4$markdown;

  var _useContext = (0, _react.useContext)(_DictionaryTerms["default"]),
      dictionaryTerms = _useContext.dictionaryTerms;

  if (!dictionaryTerms) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
  }

  var isArray = Array.isArray(children);
  var nodesArray = isArray ? children : [children];

  if (markdown) {
    // HACK: markdown Link blocks require 2 newlines before the footnote definition. They may not be supplied.
    // Ideally this would be resolved with a remark plugin, but none was found to work.
    // Error Input: 'text\n[2]: http:\\whatever'
    // Corrected Output: 'text\n\n[2]: http:\\whatever'
    var contentWithProperLinks = children.replace(/(\S)(\n\[\d)/gi, '$1\n$2'); // END HACK

    nodesArray = [(0, _server.renderToString)( /*#__PURE__*/_react["default"].createElement(_reactMarkdown["default"], {
      skipHtml: true,
      allowDangerousHtml: true
    }, contentWithProperLinks))];
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, nodesArray.map(function (nodeElement) {
    var _nodeElement$props;

    var index = (0, _nanoid.nanoid)();
    var TagName = nodeElement === null || nodeElement === void 0 ? void 0 : (_nodeElement$props = nodeElement.props) === null || _nodeElement$props === void 0 ? void 0 : _nodeElement$props.originalType;

    if (typeof nodeElement === 'string') {
      var parsedText = parseDictionaryTerms({
        dictionaryTerms: dictionaryTerms,
        text: nodeElement
      });
      return /*#__PURE__*/_react["default"].createElement(_autobahnUtilities.DOMSanitizer, {
        key: index
      }, parsedText);
    }

    if (nodeElement && nodeElement.props && nodeElement.props.children && typeof nodeElement.props.children === 'string') {
      var _parsedText = parseDictionaryTerms({
        dictionaryTerms: dictionaryTerms,
        text: nodeElement.props.children
      });

      return /*#__PURE__*/_react["default"].createElement(_autobahnUtilities.DOMSanitizer, {
        key: index,
        element: TagName
      }, _parsedText);
    }

    if (nodeElement.props.children) {
      return /*#__PURE__*/_react["default"].createElement(TagName, {
        key: index
      }, /*#__PURE__*/_react["default"].createElement(DictionaryTermsWrapper, null, nodeElement.props.children));
    }

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }));
};

DictionaryTermsWrapper.defaultProps = {
  children: undefined,
  markdown: false
};
DictionaryTermsWrapper.propTypes = {
  children: _propTypes.node,
  markdown: _propTypes.bool
};
DictionaryTermsWrapper.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "DictionaryTermsWrapper",
  "props": {
    "markdown": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "children": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "node"
      },
      "required": false
    }
  }
};
var _default = DictionaryTermsWrapper;
exports["default"] = _default;